export function popupHandler() {        
    if (typeof jQuery === 'undefined') {
        console.error('jQuery is not loaded');
        return;
    }            
    const $ = jQuery;       
    const dPopups = [], $background = $( '.popups-bg-fade' );        

    /**
     * Check if the window width is less than or equal to 1280px
     *
     * @return {boolean}
     */
    function isMobileView() {
        return $( window ).width() <= 1280;
    }

    /**
     * Check if the D_Popup is excluded from the current view
     *
     * @param  popup
     * @return {boolean}
     */
    function isExcludedFromView( popup ) {
        return ( isMobileView() && ! popup.inMobileView ) ||
        ( ! isMobileView() && ! popup.inDesktopView );
    }

    /**
     * If any D_Popup os shown, also show background fade.
     * else hide it.
     */
    function handleBackgroundFading() {        
        for ( const popup of dPopups ) {            
            if ( popup.isShown && ! isExcludedFromView( popup ) ) {                
                // $background.show();
                $background.fadeIn( 200 );
                return;
            }
        }
        // $background.hide();
        $background.fadeOut( 200 );
    }

    /**
     * On user clicking the faded background. Hide all D_Popups and faded background.
     */
    $background.on( 'click', function() {    
        console.log('background clicked');    
        for ( const popup of dPopups ) {
            if ( ! isExcludedFromView( popup ) ) {


                // stop video in iframe from playing
                const iframe = $(popup.node).find('iframe');
                console.log(iframe);
                
                if (iframe.length) {
                    console.log('stop video');
                    const src = iframe.attr('src');
                    iframe.attr('src', '');
                    iframe.attr('src', src);
                }


                popup.hide.call( popup.node );
                popup.isShown = false;
            }
        }
        handleBackgroundFading();
    } );

    /**
     * Register a node as D_Popup. Any node in this register will be hidden
     * when another is shown. You can pass options as argument.
     * show: callback function for showing node
     * hide: callback function for hiding node
     * whitelist: array of nodes not affected by this node
     * inMobileView: function is applied on small screens, default true
     * inDesktopView: function is applied on large screens, default true
     *
     * @param  options
     * @return {jQuery}
     */
    $.fn.registerAsD_Popup = function( options ) {
        // console.log( 'registerAsD_Popup called' );
        /* Set specified settings or default */
        const settings = $.extend( {
            show() {
                this.fadeIn( 500 );
                // this.show();				
            },
            hide() {
                // this.hide();
                this.fadeOut( 500 );
            },
            inMobileView: true,
            inDesktopView: true,
        }, options );

        /* Push the current node and settings to the dPopups array */
        const $popup = this;
        dPopups.push( {
            node: $popup,
            show: settings.show,
            hide: settings.hide,
            isShown: false,
            whitelist: settings.whitelist || [],
            inMobileView: settings.inMobileView,
            inDesktopView: settings.inDesktopView,
        } );

        return this;
    };

    /**
     * Shows the calling node, and hides all others in register
     */
    $.fn.showD_Popup = function() {
        const $currentPopup = this;

        for ( const popup of dPopups ) {
            /* If popup is excluded from view, continue on with the next */
            if ( isExcludedFromView( popup ) ) {
                continue;
            }

            /* if the popup is the calling node, show it */
            if ( popup.node.is( $currentPopup ) ) {
                popup.show.call( popup.node );
                popup.isShown = true;
            } else if ( ! popup.whitelist.includes( $currentPopup ) ) {
                /* if the current popup is not in the whitelist, hide it */
                popup.hide.call( popup.node );
                popup.isShown = false;
            }
        }

        handleBackgroundFading();
    };

    /**
     * Hides the calling node
     */
    $.fn.hideD_Popup = function() {
        console.log('hideD_Popup called');
        const $currentPopup = this;

        //  const iframe = $currentPopup.find('iframe');
        // console.log(iframe);
        
        // if (iframe.length) {
        //     console.log('stop video');
        //     const src = iframe.attr('src');
        //     iframe.attr('src', '');
        //     iframe.attr('src', src);
        // }

        for ( const popup of dPopups ) {
            /* if the current popup is not excluded from the current view and is the calling node */
            if ( ! isExcludedFromView( popup ) && popup.node.is( $currentPopup ) ) {
                popup.hide.call( popup.node );
                popup.isShown = false;
            }
        }

        handleBackgroundFading();
    };    
}
